import { render, staticRenderFns } from "./ShareNftLink.vue?vue&type=template&id=1512ed59&scoped=true&"
import script from "./ShareNftLink.vue?vue&type=script&lang=js&"
export * from "./ShareNftLink.vue?vue&type=script&lang=js&"
import style0 from "./ShareNftLink.vue?vue&type=style&index=0&id=1512ed59&scoped=true&lang=css&"
import style1 from "./ShareNftLink.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1512ed59",
  null
  
)

export default component.exports